
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Marie-Theres B., 70 ans, décédée le 22 octobre 2020</b>
    <br />
    <br />
    <i>Son fils se souvient:</i>
    <br />
    <p>
  «Notre mère, qui était en pleine forme, a pourtant été infectée. Son
  partenaire aussi. Il avait dix ans de plus qu’elle et avait déjà eu des
  problèmes de santé. Les deux ont dû être hospitalisés. Quelques jours après
  leur arrivée à l’hôpital, ils sont passés aux soins intensifs. Son partenaire
  s’en est sorti. Mais pas ma maman, qui est décédée après une dizaine de jours.
  Les médecins n’ont rien pu faire pour contrer le virus. L’intubation n’a eu
  aucun effet. Nous comprenons difficilement cette différence entre elle et lui.
  Ils ont pris les mêmes mesures de précaution. Elle était en bonne santé. Lui
  de nature fragile. Et pourtant… C’est le destin. Le virus n’épargne personne.
  Et la vie continue.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;